import { SET_SEARCH, RESET_SEARCH, SET_PRESERVE_SEARCH, RESET_ALL_PRESERVE_SEARCH } from "./type";

export const setSearch = (module, values) => ({
  type: SET_SEARCH,
  payload: {
    module,
    values,
  },
});

export const resetSearch = (module, values) => ({
  type: RESET_SEARCH,
  payload: {
    module,
    values,
  },
});

export const setPreserveSearch = (entity, value) => ({
  type: SET_PRESERVE_SEARCH,
  payload: { entity, value },
});

export const resetAllPreserveSearch = () => ({
    type: RESET_ALL_PRESERVE_SEARCH,
});